












import Vue from "vue";
import VaIcon from "@/components/atoms/VaIcon.vue";

export default Vue.extend({
  name: "StepComplete",
  data() {
    return {
      loading: false,
    };
  },
  components: { VaIcon },
  computed: {},
  methods: {},
});
